<div class="login-container">
  <div class="login-row">
    <div class="login-brand">
      <img
        class="login-logo-img"
        src="assets/custom/images/mh3_logo.png"
        alt="mh3"
        width="320"
        height="320" />
      <div class="login-version" *ngIf="appVersion">Version {{ appVersion }}</div>
    </div>

    <div class="login-box">
      <div class="login-header">
        <h1 class="portal-title">Logistikportal</h1>
        <h2>Anmeldung</h2>
      </div>

      <p class="login-lead">
        Bitte melden Sie sich mit Ihrer geschäftlichen E-Mail-Adresse und Ihrem Passwort an.
      </p>

      <form [formGroup]="loginForm" (ngSubmit)="tryLogin()" class="login-form">
        <div class="form-group">
          <label for="email">E-Mail-Adresse</label>
          <span class="login-field-hint">Die Adresse, mit der Ihr Zugang hinterlegt ist.</span>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control"
            [readonly]="otpStep"
            [ngClass]="{'is-invalid': submitted && f['email'].errors}"
          >
          <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
            <div *ngIf="f['email'].errors['required']">E-Mail ist erforderlich</div>
            <div *ngIf="f['email'].errors['email']">Bitte geben Sie eine gültige E-Mail-Adresse ein</div>
          </div>
        </div>

        <div class="form-group">
          <label for="password">Passwort</label>
          <span class="login-field-hint">Das Passwort, das Sie für dieses Portal vergeben haben.</span>
          <input
            type="password"
            id="password"
            formControlName="password"
            class="form-control"
            [readonly]="otpStep"
            [ngClass]="{'is-invalid': submitted && f['password'].errors}"
          >
          <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
            <div *ngIf="f['password'].errors['required']">Passwort ist erforderlich</div>
          </div>
        </div>

        <div class="form-group otp-step" *ngIf="otpStep">
          <label for="otp">PIN (5-stellig)</label>
          <span class="login-field-hint">Wir haben Ihnen einen Code per E-Mail gesendet. Bitte geben Sie ihn hier ein.</span>
          <input
            type="text"
            id="otp"
            formControlName="otp"
            class="form-control otp-input"
            maxlength="5"
            inputmode="numeric"
            autocomplete="one-time-code"
            placeholder="z. B. 12345"
            [ngClass]="{'is-invalid': submitted && loginForm.get('otp')?.errors}"
          >
          <div *ngIf="submitted && loginForm.get('otp')?.errors" class="invalid-feedback">
            <div *ngIf="loginForm.get('otp')?.errors?.['required']">PIN ist erforderlich</div>
            <div *ngIf="loginForm.get('otp')?.errors?.['pattern']">Bitte genau 5 Ziffern eingeben</div>
          </div>
        </div>

        <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            <span *ngIf="!otpStep">Anmelden</span>
            <span *ngIf="otpStep">PIN bestätigen &amp; anmelden</span>
          </button>
          <button
            *ngIf="otpStep"
            type="button"
            [disabled]="loading"
            class="btn btn-link"
            (click)="backToCredentials()"
          >
            Zurück
          </button>
          <a routerLink="/forgot-password" class="btn btn-link">Passwort vergessen?</a>
        </div>

        <div *ngIf="infoMessage" class="alert alert-info">
          {{ infoMessage }}
        </div>

        <p class="login-footnote">
          Bei Problemen mit der Anmeldung wenden Sie sich bitte an Ihre Administration.
        </p>
      </form>
    </div>
  </div>
</div>
